<template>
  <div v-if="options && options.length && paymentCurrency">
    <BasePlanItem v-for="option in options" :key="option.id"
                  :plan="option"
                  :currency="paymentCurrency"
                  :selected="selected"
                  @input="onClick"/>

  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import BasePlanItem from "@/domain/events/components/BasePlanItem.vue";

export default {
  name: "PlanOptionSelector",
  components: {BasePlanItem},
  data() {
    return {
      selectedPlan: null
    }
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    selected: {
      type: Number,
      default: null
    }
  },
  async mounted() {
    await this.fetchPaymentCurrency()
  },
  computed: {
    ...mapGetters('eventWizard', [
      'paymentCurrency'
    ])
  },
  methods: {
    ...mapActions('eventWizard', [
      'fetchPaymentCurrency'
    ]),
    onClick(option) {
      this.$emit('update:value', option.id)
      this.$emit('input', option)
    }
  }
}
</script>